import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { isPlatformServer } from '@angular/common';
import { environment } from '../../environments/environment';

import { Brand, BrandResponse } from '../models/brand';
import { Lang } from '../models/lang';

@Injectable({
  providedIn: 'root'
})
export class BrandService {

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  fetchAll(lang: Lang): Observable<Brand[]> {
    const apiUrl = this.getApiHost() + `/api/brands?lang=` + lang;
    return this.http.get<BrandResponse>(apiUrl)
      .pipe(
        map(response => {
          return response.data;
        }),
        catchError(error => {
          console.log(error);
          return of(error);
        })
      );

  }

  private getApiHost() {
    // SSRの場合、localhostにする
    if (isPlatformServer(this.platformId)) {
      return 'http://localhost';
    }
    return environment.apiHost;
  }
}
